import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Copy, Trash2, Eye, Pencil } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { PageHeader, Btn, StatusBadge } from "@/components/admin/ui";

export default function PagesList() {
  const [pages, setPages] = useState([]);
  const load = () => api.get("/admin/pages").then((r) => setPages(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    const { data } = await api.post("/admin/pages", { title: "Untitled Page", status: "draft", modules: [] });
    window.location.href = `/admin/pages/${data.id}`;
  };
  const dup = async (id) => { await api.post(`/admin/pages/${id}/duplicate`); toast.success("Duplicated"); load(); };
  const del = async (id) => { if (!window.confirm("Delete this page?")) return; try { await api.delete(`/admin/pages/${id}`); toast.success("Deleted"); load(); } catch (e) { toast.error(e.response?.data?.detail || "Cannot delete"); } };

  return (
    <div data-testid="admin-pages">
      <PageHeader title="Pages" subtitle="Create and manage website pages">
        <Btn onClick={create} data-testid="new-page-btn"><Plus size={16} /> New Page</Btn>
      </PageHeader>
      <div className="bg-white rounded-2xl border border-stone-200/80 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-stone-50 text-stone-500 text-left"><tr>
            <th className="px-5 py-3 font-medium">Title</th><th className="px-5 py-3 font-medium">Slug</th>
            <th className="px-5 py-3 font-medium">Status</th><th className="px-5 py-3 font-medium">Nav</th>
            <th className="px-5 py-3 font-medium text-right">Actions</th></tr></thead>
          <tbody>
            {pages.map((p) => (
              <tr key={p.id} className="border-t border-stone-100" data-testid={`page-row-${p.slug}`}>
                <td className="px-5 py-3 font-medium text-emerald-900">{p.title}{p.is_system && <span className="ml-2 text-[10px] uppercase bg-stone-100 text-stone-500 px-1.5 py-0.5 rounded">system</span>}</td>
                <td className="px-5 py-3 font-mono text-xs text-stone-500">/{p.slug}</td>
                <td className="px-5 py-3"><StatusBadge status={p.status} /></td>
                <td className="px-5 py-3">{p.nav_visible ? "✓" : "—"}</td>
                <td className="px-5 py-3">
                  <div className="flex justify-end gap-1">
                    {p.status === "published" && <a href={`/${p.slug}`} target="_blank" rel="noreferrer" className="p-2 rounded-lg hover:bg-stone-100 text-stone-500" title="View"><Eye size={16} /></a>}
                    <Link to={`/admin/pages/${p.id}`} className="p-2 rounded-lg hover:bg-stone-100 text-emerald-700" title="Edit"><Pencil size={16} /></Link>
                    <button onClick={() => dup(p.id)} className="p-2 rounded-lg hover:bg-stone-100 text-stone-500" title="Duplicate"><Copy size={16} /></button>
                    {!p.is_system && <button onClick={() => del(p.id)} className="p-2 rounded-lg hover:bg-red-50 text-red-500" title="Delete"><Trash2 size={16} /></button>}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
